import styled from "styled-components";

export const Page = styled.div`
  padding: 0px 30px;
  margin-top: 20px;
  header {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.secondary70};
    span {
      display: flex;
      align-items: flex-start;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary100};
      svg {
        margin-left: 5px;
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
  }
 
  .clients-logs {
    display: flex;
    .clients {
      margin-top: 30px;
      display: flex;
      width: 100%;
      flex: 60%;
      border-radius: 8px;
      flex-wrap: wrap;
      height: fit-content;
      max-height: 600px;
      gap: 30px;
      max-height: 400px;
      overflow: scroll;
    }
  
  }
`;
